'use client';
var classes = {"root":"m_bcaa9990","control":"m_375a65ef"};

export { classes as default };
//# sourceMappingURL=TableOfContents.module.css.mjs.map
